import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Layout from "./layouts/_layout.js";

import "./assets/scss/black-dashboard-react.scss";
import "./assets/css/Custom.css";
import "./assets/demo/demo.css";
import "./assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Error403 from './views/Error403'
import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import registerServiceWorker from './registerServiceWorker';
/* import Manifest from './manifest' */

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');



ReactDOM.render(
  <ThemeContextWrapper>
    <BackgroundColorWrapper>
      <BrowserRouter basename={baseUrl}>
      {/*   <Manifest /> */}
        <Switch>
        <Route path='/admin' component={() => {
            window.location.href = 'http://avarezonline.ir/admin';
            return null;
          }} />

          <Route path="/403" render={(props) => <Error403 {...props}/>}/>
          <Route path="/" render={(props) => <Layout {...props} />} />

        </Switch>
      </BrowserRouter>
    </BackgroundColorWrapper>
  </ThemeContextWrapper>,
  rootElement);

registerServiceWorker();

